var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H2.5C1.125 0 0 1.125 0 2.5V20C0 21.375 1.125 22.5 2.5 22.5H27.5C28.875 22.5 29.9875 21.375 29.9875 20L30 2.5C30 1.125 28.875 0 27.5 0ZM10 3.75C12.075 3.75 13.75 5.425 13.75 7.5C13.75 9.575 12.075 11.25 10 11.25C7.925 11.25 6.25 9.575 6.25 7.5C6.25 5.425 7.925 3.75 10 3.75ZM17.5 18.75H2.5V17.5C2.5 15 7.5 13.625 10 13.625C12.5 13.625 17.5 15 17.5 17.5V18.75ZM22.3125 13.75H24.05C24.25 13.75 24.425 13.8375 24.55 14L25.925 15.8125C26.1125 16.0625 26.0875 16.4125 25.8625 16.625L24.1625 18.325C23.9375 18.55 23.5625 18.575 23.325 18.375C21.8945 17.1591 20.8588 15.5446 20.35 13.7375C19.8834 12.1077 19.8834 10.3798 20.35 8.75C20.8557 6.94149 21.892 5.32612 23.325 4.1125C23.575 3.9 23.9375 3.9375 24.1625 4.1625L25.8625 5.8625C26.0875 6.0875 26.1125 6.4375 25.925 6.675L24.55 8.4875C24.4932 8.56662 24.418 8.63073 24.3309 8.67429C24.2438 8.71784 24.1474 8.73954 24.05 8.7375H22.3125C22.0375 9.525 21.875 10.3625 21.875 11.2375C21.875 12.1125 22.0375 12.9625 22.3125 13.75Z",
    fill: "#905F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0266b2d13aecdeb6f45012287bed5a1c.svg";
export { ForwardRef as ReactComponent };